import type { Track } from '@/lib/types';

export function TrackBadge({ track }: { track: Track | null }) {
  if (!track) {
    return <span className="track-badge track-badge--neutral">Pause</span>;
  }

  return <span className={`track-badge track-badge--${track.colorToken}`}>{track.label}</span>;
}
